import { hasWindow } from './storage';

function getScenarioStorageKey(key: string): string {
  return `DEV_PREVIEW:scenario:${key}`;
}

function isSerializedData(value: string | null): boolean {
  if (!value) {
    return false;
  }

  const normalized = value.trim();
  return normalized.startsWith('{') || normalized.startsWith('[');
}

/**
 * Reads a scenario preference from localStorage.
 */
export function getScenario(key: string, fallback: string): string {
  if (!hasWindow()) {
    return fallback;
  }

  const explicitScenario = window.localStorage.getItem(getScenarioStorageKey(key));
  if (explicitScenario) {
    return explicitScenario;
  }

  const legacyScenario = window.localStorage.getItem(`DEV_PREVIEW:${key}`);

  // WHY: Legacy scenario flags shared keys with persisted JSON. Treat only plain-string values as scenarios
  // so writes to sessions/tasks storage no longer wipe the active dev mode scenario.
  if (isSerializedData(legacyScenario)) {
    return fallback;
  }

  return legacyScenario || fallback;
}
